export const GET_TICKETS = "GET_TICKETS";
export const GET_TICKET_BY_ID = "GET_TICKET_BY_ID";
export const UPDATE_TICKET = "UPDATE_TICKET";
export const DELETE_TICKET = "DELETE_TICKET";
export const CREATE_TICKET = "CREATE_TICKET";
